
  import * as storyblokRuntime$skmJgy7vCuiHgREGizrGYDZDjbXFrkOuSOMTrqtLGK8 from '/codebuild/output/src3354122452/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$sHKKRAn1CbOWFn66qOwyfdkx77e853UbQwgKnUBH9ow from '/codebuild/output/src3354122452/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$skmJgy7vCuiHgREGizrGYDZDjbXFrkOuSOMTrqtLGK8, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$sHKKRAn1CbOWFn66qOwyfdkx77e853UbQwgKnUBH9ow, defaults: {} }
    }
  }
